import React, { useState } from 'react';
import _clone from 'lodash/clone';
import _kebabCase from 'lodash/kebabCase';
import _map from 'lodash/map';
import _remove from 'lodash/remove';
import _slice from 'lodash/slice';
import { MessageDescriptor } from '@kyruus/intl';

import {
  SearchModification,
  FilterParam,
  SearchFacetWithAppliedTerms
} from 'Src/types';
import { BasicContentFilter } from './BasicContentFilter';
import { ShowMoreButton } from './ShowMoreButton';
import { BasicFacetBody } from '../../../styles';

interface BasicContentProps {
  facet: SearchFacetWithAppliedTerms;
  labelName: MessageDescriptor;
  hideCount: boolean;
  updateSearch: (modifications: SearchModification[]) => void;
}

export const BasicContent = ({
  facet,
  labelName,
  hideCount,
  updateSearch
}: BasicContentProps) => {
  const [hideTerms, setHideTerms] = useState(true);
  const facetName = facet.field;
  const maxVisible = facet.max_visible || 5;
  const terms = _clone(facet.terms);
  const appliedTerms = _remove(terms, 'applied');

  const toggleShowMore = () => {
    setHideTerms(!hideTerms);
  };

  const handleAddFilter = (filterParam: FilterParam) => {
    setHideTerms(true);
    const modifications: SearchModification[] = [
      { action: 'append', key: 'filter', value: filterParam }
    ];
    // remove all other applied filters for the facetName if type is radio button
    if (facet.type === 'radio' && appliedTerms.length > 0) {
      const deleteFilters: SearchModification[] = appliedTerms.map(
        ({ value }) => ({
          action: 'delete_key_value',
          key: 'filter',
          value: `${facetName}:${value}`
        })
      );
      modifications.push(...deleteFilters);
    }
    updateSearch(modifications);
  };
  const handleRemoveFilter = (filterParam: FilterParam) => {
    setHideTerms(true);
    updateSearch([
      { action: 'delete_key_value', key: 'filter', value: filterParam }
    ]);
  };

  const appliedFilters = _map(appliedTerms, (term) => (
    <BasicContentFilter
      facetType={facet.type}
      term={term}
      facetName={facetName}
      hideCount={hideCount}
      toggleFilter={handleRemoveFilter}
      key={term.value}
    />
  ));

  const to_show = hideTerms
    ? Math.max(maxVisible - appliedTerms.length, 0)
    : terms.length;
  const unappliedTerms = _slice(terms, 0, to_show);
  const unappliedFilters = _map(unappliedTerms, (term) => (
    <BasicContentFilter
      facetType={facet.type}
      term={term}
      facetName={facetName}
      hideCount={hideCount}
      toggleFilter={handleAddFilter}
      key={term.value}
    />
  ));

  return (
    <>
      <BasicFacetBody
        data-testid={`filter-box-${_kebabCase(facetName)}`}
        className="no-bullets"
        id={'facet-group-' + _kebabCase(facetName)}
      >
        {appliedFilters}
        {unappliedFilters}
      </BasicFacetBody>
      <ShowMoreButton
        allTerms={facet.terms}
        facetName={facetName}
        hideTerms={hideTerms}
        labelName={labelName}
        maxVisible={maxVisible}
        onClick={toggleShowMore}
        terms={terms}
      />
    </>
  );
};
